import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';
import RenderInBody from './render_in_body';

const RenderInFullscreen = ({
  title,
  onCloseClick,
  children,
}) => (
  <RenderInBody>
    <div className="modal_wrapper" style={{ display: 'block' }}>
      <div className="modal_header">
        <div className="modal_header_info_wrapper" />
        <div className="modal_title_wrapper">
          <span className="modal_title">{ title }</span>
        </div>
        <span className="close">
          <Icon id="close" big active onClick={onCloseClick} />
        </span>
      </div>

      <div className="modal_contents_wrapper scrollable has-scroll-bars">
        <div className="modal_contents">
          { children }
        </div>
      </div>
    </div>
  </RenderInBody>
);

RenderInFullscreen.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default RenderInFullscreen;
